<template>
  <!-- 首年限时加费 -->
  <div class="td">
    <Dropdown :visible="visible" trigger="custom" @mouseleave.native="closePreview" placement="left">
      <div class="btn" @mouseover="openPreview(true)" @click="openConfigModal('activityModal', true)">
        <span v-if="topItem.sourceType == 2">{{ tableItem.isExistTemp ? '已配置' : '配置' }}</span>
        <span v-else>{{ tableItem.isExistTemp ? '查看' : '-' }}</span>
      </div>
      <template slot="list">
        <div v-for="bean in list" :key="bean.id" class="list-item">
          <div class="tools-box" style="width: 700px">
            <span>费用项名称：{{ bean.expenseItem }}</span>
            <span>费用有效期：{{ bean.expenseStartTime }}至{{ bean.expenseEndTime }}</span>
          </div>
          <Table :columns="columns" :data="bean.tempCommissionList" style="width: 700px">
            <template slot-scope="{ row }" slot="commission">
              {{ row.commission || '-' }}
            </template>
          </Table>
        </div>
        <template v-if="list.length == 0">
          <!-- 商户的团险-->
          <!-- <div class="empty-item" v-if="topItem.productCategory != 3 && topItem.sourceType == 2">该配置暂未开放，请耐心等待</div> -->
          <!-- 非商户的团险 -->
          <div class="empty-item">未配置</div>
        </template>
      </template>
    </Dropdown>
  </div>
</template>
  
<script>
import activityBase from './activityBase.config.js';
import common from './common.config.js';
export default {
  mixins: [activityBase, common],
  components: {},
  props: {
    tableItem: null,
    topItem: null
  },
  data() {
    return {
      visible: false,
      list: []
    };
  },
  computed: {},
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
</style>  